var map = {
	"./angular.png": 99497,
	"./ansible.png": 3447,
	"./artifact management.png": 4900,
	"./atlassian.png": 52599,
	"./azure credentials.png": 26992,
	"./azure machine learning.png": 471,
	"./azure-key-vault-for-osep-vault.drawio.png": 16744,
	"./azure-linux-vm.drawio.png": 32637,
	"./azure-resource-group.png": 91595,
	"./azure-windows-vm.drawio.png": 7040,
	"./c++.png": 878,
	"./core.png": 61422,
	"./dast.png": 74995,
	"./docker.png": 74791,
	"./documentation.png": 36157,
	"./error.png": 73745,
	"./fastlane.png": 495,
	"./gitlab.png": 7790,
	"./mkdocs.png": 61762,
	"./multiCloudLogo.png": 20648,
	"./net.png": 12202,
	"./python.png": 30437,
	"./react.png": 16918,
	"./swift.png": 42794,
	"./terraform aws.png": 40724,
	"./terraform azure.png": 21614,
	"./terraform gcp.png": 76105,
	"./terraform.png": 10083,
	"./typescript.png": 32322,
	"./visual studio code.png": 62706,
	"./x.png": 38523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65336;